import { isDropboxLink, parseDropboxLink } from "@utils/url";

export const processUrls = (urls:string[]):string[] => {
	return urls.map(u => {
		if(isDropboxLink(u)){
			return parseDropboxLink(u);
		}
		return u;
	});
};